import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardProvider, useDashboardContext } from '../../../context/DashboardContext';
import PartnerDashboardHero from '../../../components/Dashboard/PartnerDashboardHero';
import ReservationStatsCards from '../../../components/Dashboard/ReservationStatsCards';
import UpcomingReservations from '../../../components/Dashboard/UpcomingReservations';
import RecentReservationsAndReviews from '../../../components/Dashboard/RecentReservationsAndReviews';

const RestaurantHomeContentInner = () => {
  const navigate = useNavigate();

  const {
    loading,
    stats,
    upcomingReservations,
    recentReservations,
    recentReviews,
    fetchDashboardData
  } = useDashboardContext();

  useEffect(() => {
    const token = localStorage.getItem('token_partner_restaurant');
    let id = localStorage.getItem('id_partner_restaurant');

    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        id = payload.business_id || payload._id || id;
      } catch (e) {
        console.error('Error decoding restaurant token:', e);
      }
    }

    if (token && id) {
      fetchDashboardData('restaurant', id, token);
    }
  }, [fetchDashboardData]);

  if (loading) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <div className="w-10 h-10 border-4 border-[#067978] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6 sm:space-y-8 animate-in fade-in duration-700 pb-10">
      

      {/* Section 1: Poster Hero Slider */}
      <PartnerDashboardHero category="restaurant" />

      {/* Section 2: 2 Stat Cards (Active Reservation & Total Reservations) */}
      <ReservationStatsCards
        activeReservations={stats.activeReservations}
        totalReservations={stats.totalReservations}
      />

      {/* Section 3: Upcoming Reservations */}
      <UpcomingReservations
        upcomingReservations={upcomingReservations}
        navigate={navigate}
        bookingPath="/restaurant/booking"
      />

      {/* Section 4: 2-Column Grid (Recent Reservations & Recent Reviews) */}
      <RecentReservationsAndReviews
        recentReservations={recentReservations}
        recentReviews={recentReviews}
        navigate={navigate}
        bookingPath="/restaurant/booking"
        reviewsPath="/restaurant/reviews"
      />
    </div>
  );
};

const DashboardHome = () => (
  <DashboardProvider>
    <RestaurantHomeContentInner />
  </DashboardProvider>
);

export default DashboardHome;
